import '../chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.TimeseriesChartView extends Monitoring.Views.Charts.ChartView
  template: JST['backbone/templates/monitoring/charts/generic_chart']
  benchmarkActionTemplate: JST['backbone/templates/monitoring/charts/custom_benchmark_action']
  className: 'processing item w2 time-series'
  valueField: 'count'

  events:
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facets = @options.facets
    @_settings = @options.settings
    @container = @options.container
    values = @facets['date']
    @trigger('masonry')

    if values
      @initialTime = values.min
      @finalTime = values.max

  titleWithExtra: ->
    @title

  render: (options = {}) =>
    @$el.html(@template({
      title: @titleWithExtra()
    }))
    @interval = if options.interval then options.interval else @calculateInterval(@initialTime, @finalTime)
    @intervalParam = @interval.toString() + 'm'
    @series = []
    @singularSeries = []
    @accumulatedSeries = []
    @accumulated = false
    @addSeries()

  renderChart: =>
    @$el.find('.chart').empty()

    @initialTime = _.min(serie.values[0].time for serie in _.filter(@series, (serie) -> serie.values && serie.values[0]))
    @finalTime = _.max(serie.values[serie.values.length - 1].time for serie in _.filter(@series, (serie) -> serie.values && serie.values[0]))
    for serie in @series
      serie.data = @getTimeSeries(serie.values, @initialTime, @finalTime)

    _.each(@options.eventList, (event) =>
      if(event.end_date && event.end_date != "")
        @series.push({
          type: 'flags',
          name: event.name+' ends',
          color: '#222222',
          shape: 'squarepin',
          y: -55,
          data: [
            { x: new Date(event.end_date), title: event.name+' ends' }
          ],
          showInLegend: false
        })
      @series.push({
        type: 'flags',
        name: event.name,
        color: '#333333',
        shape: 'squarepin',
        y: -55,
        data: [
          { x: new Date(event.start_date), title: event.name }
        ],
        showInLegend: false
      })
    )
    toggleFlags = () =>
      _.each(@chart.series, (series) =>
        if (series.visible && series.type == 'flags')
          series.hide()
        else
          series.show();
      )
    self = @
    options = {
      title:
        text: null
      chart:
        renderTo: @$el.find('.chart')[0]
        type: 'spline'
        zoomType: 'x'
        marginTop: 50
        events:
          selection: (event) => @onTimeseriesSelection(event)

      legend:
        verticalAlign: 'bottom'
        align: 'center'
        layout: 'horizontal'
        borderWidth: 0
        margin: 6
        maxHeight: 55
      plotOptions:
        spline:
          marker:
            enabled: false
            states:
              hover:
                enabled: true
          pointInterval: @interval * 60000
          pointStart: @initialTime
        area:
          stacking: 'percent'
          pointInterval: @interval * 60000
          pointStart: @initialTime
          marker:
            enabled: false
            states:
              hover:
                enabled: true
      tooltip:
        positioner: (labelWidth, labelHeight, point) ->
          chart = this.chart
          pointX = if (point.plotX + labelWidth > chart.plotWidth) then point.plotX + chart.plotLeft - labelWidth - 10 else point.plotX + chart.plotLeft + 10
          x = if pointX > 0 then pointX else 0
          y = if point.plotY + chart.plotTop - 20 > 35 then point.plotY + chart.plotTop - 20 else 35
          return { x: x , y: y }
        formatter: ->
          f = self._tooltipFormatter.bind(@)
          f(self)
      xAxis:
        type: 'datetime'
      yAxis:
        title: null
      series: @series
      exporting:
        buttons:
          contextButton:
            menuItems: []
            x: -12
        sourceWidth: @$el.find('.chart').width()
        sourceHeight: @$el.find('.chart').height()
        scale: 1
        chartOptions:
          legend:
            maxHeight: 'auto'
    }

    menuItems = @translatedItems(Highcharts.getOptions().exporting.buttons.contextButton.menuItems)
    menuItems = menuItems.concat({separator:true})
    unless @accumulated
      menuItems = menuItems.concat({
        text: I18n.t('monitoring.dashboard.charts.export_options.accumulated')
        onclick: (() => @renderAccumulatedChart())
      })
    else
      menuItems = menuItems.concat({
        text: I18n.t('monitoring.dashboard.charts.export_options.disable_accumulated')
        onclick: (() => @renderSingularChart())
      })
    menuItems = menuItems.concat({separator:true})
    unless window.sharedSession
      menuItems = menuItems.concat({
        text: I18n.t('monitoring.dashboard.charts.export_options.insert_commentary')
        onclick: (() => @displayNote())
      })
    menuItems = menuItems.concat({separator:true})
    menuItems = menuItems.concat({
      text: I18n.t('monitoring.dashboard.charts.export_options.automatic')
      onclick: (() => @render())
    })
    menuItems = menuItems.concat(@exportingOptions)
    menuItems = menuItems.concat({
      text: I18n.t('monitoring.dashboard.charts.export_options.flags')
      onclick: (() -> toggleFlags())
    })
    options.exporting.buttons.contextButton.menuItems = menuItems

    linkToNote = $('<a id="insert_note'+@chart_note_name()+'" class="insert-note no-print" style="cursor:pointer;position:absolute;top:15px;right:111px;z-index:500;"><i class="fa fa-pencil-square-o no-print" aria-hidden="true" style="font-size:17px;color:#000000;transform:scale(1.1)"></i></a>')
    @$el.find('#close_chart').before(linkToNote)
    @noteChart = new Monitoring.Views.Charts.NoteChartView( @chart_note_name() )
    @$el.append(@noteChart.render(@settings().note).el)
    @addExtraMenuItems()

    chartOptions = $.extend(true, {}, @chartOptions)
    @chart = new Highcharts.Chart($.extend(true, options, chartOptions))
    @_settings.zoom = undefined if @_settings.zoom && !@_settings.zoom.min
    @applyChartZoom()
    @$el.removeClass('processing')

  renderAccumulatedChart: =>
    @_settings.zoom = undefined
    @series = @accumulatedSeries
    @$el.html(@template({
      title: @titleAccumulated()
    }))
    @accumulated = true
    @renderChart()
    @trigger('masonry')

  renderSingularChart: =>
    @_settings.zoom = undefined
    @series = @singularSeries
    @$el.html(@template({
      title: @titleWithExtra()
    }))
    @accumulated = false
    @renderChart()
    @trigger('masonry')

  addSerie: (name, values, totalSeries, color) =>
    series = {
      name: name
      values: values
      events: {
        click: @_previewSearch unless @_settings.avoid_preview
        legendItemClick: @legendItemClickEvent
      }
      visible: @getVisibilityFor(name)
    }
    if color then series['color'] = color
    @singularSeries.push(series)
    @accumulatedSeries.push(@accumulateSeries(series))
    @series = if @accumulated then @accumulatedSeries else @singularSeries

    # Render chart when all requests are completed
    if @series.length == totalSeries
      @renderChart()
      @trigger('masonry')

  _previewSearch: (event) =>
    @createPreviewDashboard(@getNewQuery(event))

  getNewQuery: (event) ->
    query         = @searchQuery.deepCopy()
    from_int      = event.point.x
    to_int        = event.point.x + this.interval * 60000
    from_iso      = @searchQuery.get('date_from_ISO') || @date_from_realtime || new Date(from_int) || @searchQuery.get('post_from_ISO')
    to_iso        = @searchQuery.get('date_to_ISO')   || @date_to_realtime || new Date(to_int)
    from_iso_int  = Date.parse(from_iso)
    to_iso_int    = Date.parse(to_iso) || Date.now()
    date_from_int = Math.max(from_int, from_iso_int)
    date_to_int   = Math.min(to_int, to_iso_int)

    # when selects the last point of the timeserie, Math.min(to_int, to_iso_int) could be lower than from_int.
    # In thtat case, select Math.max(to_int, to_iso_int) instead of before
    if (date_to_int < date_from_int)
      date_to_int = Math.max(to_int, to_iso_int)

    if @interval == 10080
      if date_from_int != from_iso_int
        date_from_int    = @addUTCOffset(date_from_int)
      if date_to_int != to_iso_int
        date_to_int      = @addUTCOffset(date_to_int)
    query.addDateFrom(date_from_int)
    query.addDateTo(date_to_int)
    query.removeDateFromRealtime()
    return query

  addUTCOffset: (time_int) ->
    a = new Date()
    time_zone_offset = a.getTimezoneOffset()/60
    time = @searchQuery._parseDate(time_int)
    time.setHours(time.getHours() + time_zone_offset)
    time.getTime()

  getTimeSeries: (values, initialTime, finalTime) ->
    step = @interval * 60000
    last = initialTime - step
    series = []
    _.each(values, (value) =>
      zeros = Math.floor((value.time - last) / step) - 1
      if zeros >= 1
        zeros = (0 for x in [1..zeros])
        series = series.concat(zeros)
      last = value.time
      series.push(value[@valueField])
    )
    finalZeros = Math.floor((finalTime - last) / step)
    if finalZeros >= 1
      if @accumulated
        finalZeros = (_.last(series) for x in [1..finalZeros])
      else
        finalZeros = (0 for x in [1..finalZeros])
      series = series.concat(finalZeros)
    return series

  calculateInterval: (initialTime, finalTime) ->
    per_week = {text: I18n.t('monitoring.dashboard.charts.export_options.week'), onclick: (() => @render({interval: 1440*7}))}
    per_day = {text: I18n.t('monitoring.dashboard.charts.export_options.day'), onclick: (() => @render({interval: 1440}))}
    per_hour = {text: I18n.t('monitoring.dashboard.charts.export_options.hour'), onclick: (() => @render({interval: 60}))}
    per_half = {text: I18n.t('monitoring.dashboard.charts.export_options.half'), onclick: (() => @render({interval: 30}))}
    per_minute = {text: I18n.t('monitoring.dashboard.charts.export_options.minute'), onclick: (() => @render({interval: 1}))}

    minutes = (finalTime - initialTime) / 60000
    if minutes <= 120 # Less than 2 hours => 1 minute interval
      @exportingOptions = [per_hour, per_half, per_minute]
      return 1
    else if minutes <= 720 # Less than 12 hours => 5 minutes interval
      @exportingOptions = [per_hour, per_half, per_minute]
      return 5
    else if minutes <= 1440 # Less than 1 day => 10 minutes interval
      @exportingOptions = [per_hour, per_half, per_minute]
      return 10
    else if minutes <= 1440*7 # Less than 1 week => 60 minutes interval
      @exportingOptions = [per_day, per_hour, per_half, per_minute]
      return 60
    else if minutes <= 1440*30 # Less than 30 days => 6 hours interval
      @exportingOptions = [per_week, per_day, per_hour,  per_half]
      return 360
    else if minutes <= 1440*120 # Less than 120 days => 1 day interval
      @exportingOptions = [per_week, per_day, per_hour, per_half]
      return 1440
    else # Anything else => 1 week interval
      @exportingOptions = [per_week, per_day, per_hour, per_half]
      return 1440*7

  accumulateSeries: (series) =>
    new_series = {}
    new_series['name'] = series.name
    new_series['events'] = series.events
    new_series['color'] = series.color
    new_values = []
    offset = 0
    _.each(series.values, (value) =>
      new_value = {}
      new_value['time'] = value.time
      new_value['count'] = value.count + offset
      offset += value.count
      new_values.push(new_value)
    )
    new_series['values'] = new_values
    return new_series

  _tooltipFormatter: (maybe_options) ->
    a = new Date()
    time_zone_offset = a.getTimezoneOffset()/60
    interval = if maybe_options.interval then maybe_options.interval else maybe_options.calculateInterval(maybe_options.initialTime, maybe_options.finalTime)
    to = @point.x + interval * 60000
    to = new Date(to)
    date = if @point.show_date then new Date(@point.show_date) else new Date(@point.x)
    if interval == 10080
      to.setHours(to.getHours()+time_zone_offset)
      date.setHours(date.getHours()+time_zone_offset)
    "<b>#{@point.series.name}</b><br/> From: #{date.format('ddd MMM D YYYY HH:mm')} To: #{to.format('ddd MMM D YYYY HH:mm')} <br/> #{@point.y}"

  titleAccumulated: =>
      @titleWithExtra() + " (#{I18n.t('monitoring.dashboard.charts.export_options.accumulated')})"

  addExtraMenuItems: =>
    # subclass responsability

  removeSerie: (series, name) ->
    serie = _.find series, (s) -> s.name is name
    if serie
      series.splice(series.indexOf(serie), 1)
      return true
    false
